/* eslint-disable no-await-in-loop */
import { OAuth2Client } from '@kolorado/oauth';
import { AxiosResponse } from 'axios';
import {
  PostWiFiConfigurationResponse,
  RemoveWiFiConfigurationRequest,
  RemoveWiFiConfigurationResponse,
  WiFiConfigurationResponse,
} from '../entities/wifi-configurations-v1';
import { WifiConfigStatusesInput } from './types';
import { axiosInstance } from "../axios-instance";

class WifiConfigurations {
  private client: OAuth2Client | null;

  private baseUrl: string;

  constructor(authClient: OAuth2Client | null, baseUrl: string) {
    this.client = authClient;
    this.baseUrl = baseUrl;
  }

  configStatuses(
    queryParameters: WifiConfigStatusesInput,
  ): Promise<AxiosResponse<WiFiConfigurationResponse>> {
    const accessToken = localStorage.getItem('accessToken');
    return axiosInstance.get<WiFiConfigurationResponse>(`${this.baseUrl}/configStatuses`, {
      params: queryParameters,
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });
  }

  queueConfigs(body: any): Promise<AxiosResponse<PostWiFiConfigurationResponse>> {
    const accessToken = localStorage.getItem('accessToken');
    return axiosInstance.post<PostWiFiConfigurationResponse>(`${this.baseUrl}/queueConfigs`, body, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });
  }

  removeConfigs(
    body: RemoveWiFiConfigurationRequest,
  ): Promise<AxiosResponse<RemoveWiFiConfigurationResponse>> {
    const accessToken = localStorage.getItem('accessToken');
    return axiosInstance.post<RemoveWiFiConfigurationResponse>(`${this.baseUrl}/removeConfigs`, body, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });
  }
}

export default WifiConfigurations;
